import {get_all_check_ins} from '~/api/zero-api';
import useDataLoader from '~/hooks/shared/useDataLoader';


export default function useMyCheckInsLoader(options = {}) {
    return useDataLoader(get_all_check_ins, options);
}
